import { Component } from "react";

class ToolTip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  open = () => {
    this.setState({ isOpen: true });
  };

  close = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen } = this.state;
    return this.props.children({
      close: this.close,
      open: this.open,
      isOpen,
      ...this.props,
    });
  }
}

export default ToolTip;
